export default __webpack_public_path__ + "81ef692dbc7cd7d8cacc39ca3a87c06c.svg";